<template>
	<div>
		<div class="wrapper">
			<div class="profilePicDiv">
				<img class="profilepic" src="../assets/profilepicture.jpg"/>
			</div>
			<div id="MikeHayes"/>
			<hr class="hr-text" data-content="CONTACT"/>
			<div id="contact">
				<a href="mailto:mikeghayes93@gmail.com?subject=Website Contact">
					<div id="contactInfo"/>
				</a>
				<a href="https://www.linkedin.com/in/mikehayes93/">
					<i class="fab fa-linkedin"> 
						<font style="font-family:monospace; font-size:13px"> /mikehayes93</font>
					</i>
				</a> | 
				<a href="http://github.com/applezjuice">
					<i class="fab fa-github-square">
						<font style="font-family:monospace; font-size:13px"> /applezjuice</font>
					</i>
				</a>
			</div>
			<hr class="hr-text" data-content="VISION"/>
			<div class="vision">
				<p class="visionHeader">Technical Enthusiast</p>
                I am a passionate and continuously learning software developer with a strong interest in expanding technical expertise beyond my core domain. I actively explore topics such as cloud infrastructure, hardware trends, engineering frameworks, and code optimization. Additionally, I am deeply invested in enhancing user experience and usability, ensuring that the software I develop is both efficient and user-friendly.
			</div>
			<hr class="hr-text" data-content="SKILLS"/>
			<div id="skillsContainer">
				<div class="skills">
				<ul class="column-list">
					<li style="--animation-order: 1;">DotNetCore</li>
					<li style="--animation-order: 2;">C# / Python / C++</li>
					<li style="--animation-order: 3;">xUnit Framework</li>
					<li style="--animation-order: 4;">VueJs / React</li>
					<li style="--animation-order: 5;">WPF</li>
					<li style="--animation-order: 6;">SQL</li>
					<li style="--animation-order: 7;">Unity / Godot</li>
					<li style="--animation-order: 8;">Git</li>
					<li style="--animation-order: 9;">Jenkins / CICD</li>
					<li style="--animation-order: 10;">Octopus</li>
					<li style="--animation-order: 11;">Jira / Confluence</li>
					<li style="--animation-order: 12;">AWS / GCP / Alibaba</li>
					<li style="--animation-order: 13;">Docker / GKE</li>
					<li style="--animation-order: 14;">Terraform</li>
					<li style="--animation-order: 15;">Ansible</li>
					<li style="--animation-order: 16;">Networking</li>
				</ul>
				</div>
				<div id="pie-chart"/>
			</div>
			<hr class="hr-text" data-content="EMPLOYMENT HISTORY"/>
			<div id="employmentContainer"><br>
				<div class="employment">
					<div class="employmentHeader">
						<div class="employmentLeft">
							<div class="employmentTitle" id="employmentOneHeading"/>
							<div class="employmentInfo">Senior Software Engineer <font style="color:tomato;">2025 - Present</font></div>
							<div class="employmentInfo">Software Engineer <font style="color:tomato;">2023 - 2025</font></div>
							<div class="employmentInfo">Associate Software Engineer <font style="color:tomato;">2022 - 2023</font></div>
						</div>
						<div class="employmentLogo">
							<img class="emplogo" src="../assets/blizzard.png"/>
						</div>
					</div>
					<hr class="hr-text"/>
                    Deploy and maintain the OW2 release pipeline globally
                    <br><br>Architect solutions in multiple programming languages some of which are as follows: an API to manage local content and upload to the steamworks pipeline, an API for our shop CDN, and an API + frontend for updating multiple development environments across multiple datacenters.
                    <br><br>Created and maintain a solution for external 3rd party partners to access internal APIs leveraging Google Apigee and Alibaba API Gateway. The solution also incorporates security best practices such as utilizing OAuth 2.0
                    <br><br>Maintain multiple terraform and ansible repositories for server infrastructure configuration and deployment.
                    <br><br>Revamped our entire persistence engine increasing performance by 150% whilst utilizing time slicing and back pressure techniques to reduce system load by telling upstream systems to send data to another persistence server when it is overloaded.
					<hr class="hr-text"/>
				</div>
				<div class="employment">
					<div class="employmentHeader">
						<div class="employmentLeft">
							<div class="employmentTitle" id="employmentThreeHeading"/>
							<div class="employmentInfo">Associate Software Engineer <font style="color:tomato;">2020 - 2022</font></div>
						</div>
						<div class="employmentLogo">
							<img class="emplogo" src="../assets/blizzard.png"/>
						</div>
					</div>
					<hr class="hr-text"/>
					Develop and maintain a breadth of Corporate Applications such as our internal game key management system, our internal crediting system, and many other GNOC tooling.
					<br><br>Troubleshoot issues with deployed projects and write clean and testable code around the bugs so they would not occur again in the future.
					<br><br>Designed and implemented our internal identity as a service database for our employee data.
					<br><br>Work with our product design team and our front-end team to fully develop applications that are used company wide.
					<hr class="hr-text"/>
				</div>
				<div class="employment">
					<div class="employmentHeader">
						<div class="employmentLeft">
							<div class="employmentTitle" id="employmentFourHeading"/>
							<div class="employmentInfo">Network Administrator <font style="color:tomato;">2017 - 2020</font></div>
						</div>
						<div class="employmentLogo">
							<img class="emplogo" src="../assets/blizzard.png"/>
						</div>
					</div>
					<hr class="hr-text"/>
					Architecting and deploying network infrastructure for 70%+ of Blizzard's internal / external events globally such as PAX, Blizzcon, and OWL
					<br><br>Troubleshooting and fixing LiveOps issues to the network infrastructure for any event that I have deployed
					<br><br>Automating network tasks through ansible using python
					<br><br>Developing web applications to enhance day-to-day tasks using flask / python
					<br><br>Testing new POC's and integrate the technology stack into our events
					<br><br>Working closely with SRE's on game teams to troubleshoot issues of unreleased builds at events
					<hr class="hr-text"/>
				</div>
				<div class="employment">
					<div class="employmentHeader">
						<div class="employmentLeft">
							<div class="employmentTitle" id="employmentFiveHeading"/>
							<div class="employmentInfo">Network Services Engineer <font style="color:tomato;">2014 - 2017</font></div>
						</div>
						<div class="employmentLogo">
							<img class="emplogoRh" src="../assets/rht.png"/>
						</div>
					</div>
					<hr class="hr-text"/>
					Deployed Cisco's SDWAN (iWAN) overseas to bring the overall project back on track.
					<br><br>Deployment of DMVPN to 250+ field offices
					<br><br>Working closely with vendors to and carriers to perform circuit upgrades (MPLS + DIA)
					<br><br>TA with the DevOps team developing scripts for deploying new VMs into AWS using Chef.
				</div>
			</div>
			<hr class="hr-text projhr" data-content="PROJECTS"/>
			<div class="projectsContainer">
				<div class="projectsList">
					<ul class="projects-column-list">
						<div class="wrappertest"><li v-on:click="loadProjectDiv('project1')" style="--animation-order: 1;">Stats Site <br>(.NETCore / VueJS / MySQL)</li></div>
						<div class="wrappertest"><li v-on:click="loadProjectDiv('project2')" style="--animation-order: 2;">Blizzard Gamejam 2019 <br>(Smash Attraction - Unity C#)</li></div>
						<div class="wrappertest"><li v-on:click="loadProjectDiv('project3')" style="--animation-order: 3;">Blizzard Gamejam 2022 <br>(ZOMG - Unity C# Netcode)</li></div>
						<div class="wrappertest"><li v-on:click="loadProjectDiv('project4')" style="--animation-order: 4;">Blizzard Gamejam 2021 <br>(Faintsight - Unity C#)</li></div>
						<!--https://mhayes93.itch.io/faintsight-->
					</ul>
				</div>
				<hr class="hr-text"/>
				<div class="projectDetails">
					<div id="project1" v-show="project1" class="v-fade projectDet">
                        <div>
                            <a href="https://stats.project-homecoming.com/#/">Project Homecoming Stats Website</a>
                        </div>
                        <div>
                            A website utilized by a private racing server leveraging VueJS, a custom C# API, MySQL, and Firebase. Users race results get added to their racerid then they have stats based off of machine learning and a prediction on where the system would thing they should end up based off their current ELO
                        </div>
                        <div>
                            <img class="projImages" style="width:525px;" src="../assets/statswebsite2.png"/>
                        </div>
					</div>
					<div id="project2" v-show="project2" class="v-fade projectDet">
						Blizzard Gamejam 2019 | Smash Attraction
					</div>
					<div id="project3" v-show="project3" class="v-fade projectDet">
                        ZOMG is a networked zombie game where 3 people play on a team with a first person perspective, the attackers, while 1 person plays from a top down view, the defender. The objective of the attackers is to get to the center of the map and destroy the zombie heart while fighting off zombies spawned by the defender.
                        <div>
                            <img class ="projImages" style="width:525px;" src="../assets/zombie.png"/>
                        </div>
					</div>
					<div id="project4" v-show="project4" class="v-fade projectDet">
						Blizzard Gamejam 2021 | Faintsight
					</div>
				</div>
			</div>

			<transition name="fade">
				<div id="pagetop" class="topArrow" v-show="scY > 50" @click="toTop">
					<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
						stroke="#ffff"
						stroke-width="1" stroke-linecap="square" stroke-linejoin="arcs">
						<path d="M18 15l-6-6-6 6"/>
					</svg>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import * as d3 from 'd3'

export default {
	name: 'HomePage',
	props: {
		msg: String
	},
	
	data() {
		return {
			show: true,
			textData : 'Mike Hayes'.split('').map( (d, i) => ({
				letter  : d,
				index   : i,
				pos     : i
				})),
			locationText : 'Irvine, California 92618'.split('').map( (d, i) => ({
				letter  : d,
				index   : i,
				pos     : i
				})),
			contactText : 'Email: MikeGHayes93@gmail.com'.split('').map( (d, i) => ({
				letter  : d,
				index   : i,
				pos     : i
				})),
			employmentOneText : 'BLIZZARD ENTERTAINMENT | Overwatch'.split('').map( (d, i) => ({
				letter  : d,
				index   : i,
				pos     : i
				})),
			employmentTwoText : 'BLIZZARD ENTERTAINMENT | Associate Software Engineer'.split('').map( (d, i) => ({
				letter  : d,
				index   : i,
				pos     : i
				})),
			employmentThreeText : 'BLIZZARD ENTERTAINMENT | Corp Apps'.split('').map( (d, i) => ({
				letter  : d,
				index   : i,
				pos     : i
				})),
			employmentFourText : 'BLIZZARD ENTERTAINMENT | IT Events'.split('').map( (d, i) => ({
				letter  : d,
				index   : i,
				pos     : i
				})),
			employmentFiveText : 'ROBERT HALF TECHNOLOGY | Projects'.split('').map( (d, i) => ({
				letter  : d,
				index   : i,
				pos     : i
				})),
			nameSvg: '',
			employmentOneSvg: '',
			employmentTwoSvg: '',
			employmentThreeSvg: '',
			contactSvg: '',
			employmentOneLETTER_WIDTH : '',
			employmentOneWIDTH        : '',
			employmentOneHEIGHT       : '',
			ContactLETTER_WIDTH : '',
			ContactWIDTH        : '',
			ContactHEIGHT       : '',
			locationSvg: '',
			locationLETTER_WIDTH : '',
			locationWIDTH        : '',
			locationHEIGHT       : '',
			LETTER_WIDTH : '',
			WIDTH        : '',
			HEIGHT       : '',
			scTimer: 0,
			scY: 0,
			skillDataSet: {
				skills: {'C#': 40,'Python': 40, 'C++': 25, 'Unity':15, 'SQL':25, 'VueJS':15, 'xUnit': 25}
			},
			pieParams: {
				width: '',
				height: 300,
				radius: '',
				color: '',
				svg: ''
				},

			project1: true,
			project2: false,
			project3: false,
			project4: false,
		};
	},

	mounted() {
		window.addEventListener('scroll', this.handleScroll);
		this.testingD3Text();
		this.loadPie();
	},

	methods: {
		loadProjectDiv(project){
			if (this.show)
			{
				this.show = false;
				var i;
				for (i = 1; i <= 4; i++)
				{
					var projectname = 'project' + i;
					this[projectname] = false
				}
			}
			this.show = !this.show
			this[project] = true;
		},

		loadPie(){
			this.pieParams.width = d3.select('#pie-chart').node().offsetWidth;
			this.pieParams.svg = d3.select('#pie-chart').append('svg').attr('width', '300px').attr('height','300px');
			this.pieParams.color = d3.scaleOrdinal().domain(Object.values(this.skillDataSet.skills)).range(d3.schemeCategory10);

			var g = this.pieParams.svg.attr('height', this.pieParams.height)
					.append('g')
					.attr('transform', 'translate(' + this.pieParams.width/2 +  ',' + this.pieParams.height/2 + ')');
					
			this.pieParams.radius = Math.min(this.pieParams.width, this.pieParams.height) / 2;

			var pie = d3.pie()
				.sort(null);

			var arc = d3.arc()
				.innerRadius(this.pieParams.radius - 100)
				.outerRadius(this.pieParams.radius - 50);

			let thisColor = this.pieParams.color;
			var data_ready = pie(Object.entries(this.skillDataSet.skills))

			var path = g.selectAll("path")
				.data(pie(Object.values(this.skillDataSet.skills)))
				.enter().append("path")
				.attr("fill", function(d, i) {
					 return thisColor(i); })
				.transition()
				.duration(function(d, i) {
				return i * 800;
				})
				.attrTween('d', function(d) {
					var i = d3.interpolate(d.startAngle+0.1, d.endAngle);
					return function(t) {
						d.endAngle = i(t);
						return arc(d);
					}
				});
			
			this.pieParams.svg.append("g")
	  			.attr("class", "labels")
				  .attr('transform', 'translate(' + this.pieParams.width/2 +  ',' + this.pieParams.height/2 + ')');
			this.pieParams.svg.append("g")
	  			.attr("class", "lines")
				  .attr('transform', 'translate(' + this.pieParams.width/2 +  ',' + this.pieParams.height/2 + ')');;

			var outerArc = d3.arc()
				.outerRadius(this.pieParams.radius * 0.9)
				.innerRadius(this.pieParams.radius * 0.9);
			
			this.pieParams.svg.selectAll('path')
			.data(pie(Object.values(this.skillDataSet.skills)))
			.enter()
			.append('path')
			.attr('d', arc)
			.attr('fill', (d,i)=> color(i));
			
			let self = this;
			var testPie = pie(Object.values(this.skillDataSet.skills));
			let mergedData = {...testPie, ...this.skillDataSet.skills};

			var i;
			for (i = 0; i < data_ready.length; i++) {
				data_ready[i].value = testPie[i].value;
				data_ready[i].startAngle = testPie[i].startAngle;
				data_ready[i].endAngle = testPie[i].endAngle;
			}

			var label = this.pieParams.svg.select('.labels').selectAll('text')
						.data(data_ready)
						.enter()
						.append('text')
						.attr('dy', '.35em')
						.attr("font-weight",600)
						.html(function(d) {
							return d.data[0];
						})
						.attr('transform', function(d) {
							var pos = arc.centroid(d);
							pos[0] = pos[0] * .7;
							pos[1] = pos[1] * .9;
							return 'translate(' + pos + ')';
						})
						.style('text-anchor', function(d) {
							return (midAngle(d)) < Math.PI ? 'start' : 'end';
						})
						.style("opacity", 0)
						.transition()
						.delay(1000)
						.duration(2000)
						.ease(d3.easeLinear)
						.style("opacity", 1);
		

			
			
			function midAngle(d) { return d.startAngle + (d.endAngle - d.startAngle) / 2; } 
			
		},

		handleScroll: function () {
			if (this.scTimer) return;
			this.scTimer = setTimeout(() => {
			this.scY = window.scrollY;
			clearTimeout(this.scTimer);
			this.scTimer = 0;
			}, 100);
		},
		toTop: function () {
			window.scrollTo({
			top: 0,
			behavior: "smooth"
			});
		},

		testingD3Text(){
			this.LETTER_WIDTH = 22;
			this.WIDTH        = this.LETTER_WIDTH * this.textData.length;
			this.HEIGHT       = 80;

			this.nameSvg = d3.select('#MikeHayes').append('svg')
			.attr('width', this.WIDTH)
			.attr('height', this.HEIGHT)
			.append('g')
				.attr('transform', 'translate(0,' + (this.HEIGHT/2) + ')');

			this.ContactLETTER_WIDTH = 12;
			this.ContactWIDTH        = this.ContactLETTER_WIDTH * this.contactText.length;
			this.ContactHEIGHT       = 24;

			this.contactSvg = d3.select('#contactInfo').append('svg')
			.attr('width', this.ContactWIDTH)
			.attr('height', this.ContactHEIGHT)
			.append('g')
				.attr('transform', 'translate(0,' + (this.ContactHEIGHT/2) + ')');

			this.locationLETTER_WIDTH = 12;
			this.locationWIDTH        = this.locationLETTER_WIDTH * this.locationText.length;
			this.locationHEIGHT       = 24;

			this.locationSvg = d3.select('#locationInfo').append('svg')
			.attr('width', this.locationWIDTH)
			.attr('height', this.locationHEIGHT)
			.append('g')
				.attr('transform', 'translate(0,' + (this.locationHEIGHT/2) + ')');

			this.employmentOneLETTER_WIDTH = 10;
			this.employmentOneWIDTH        = (this.employmentOneLETTER_WIDTH + 6) * this.employmentThreeText.length;
			this.employmentOneHEIGHT       = 24;

			this.employmentOneSvg = d3.select('#employmentOneHeading').append('svg')
			.attr('width', this.employmentOneWIDTH)
			.attr('height', this.employmentOneHEIGHT)
			.append('g')
				.attr('transform', 'translate(0,' + (this.employmentOneHEIGHT/2) + ')');

			this.employmentTwoSvg = d3.select('#employmentTwoHeading').append('svg')
			.attr('width', this.employmentOneWIDTH)
			.attr('height', this.employmentOneHEIGHT)
			.append('g')
				.attr('transform', 'translate(0,' + (this.employmentOneHEIGHT/2) + ')');

			this.employmentThreeSvg = d3.select('#employmentThreeHeading').append('svg')
			.attr('width', this.employmentOneWIDTH)
			.attr('height', this.employmentOneHEIGHT)
			.append('g')
				.attr('transform', 'translate(0,' + (this.employmentOneHEIGHT/2) + ')');

			this.employmentFourSvg = d3.select('#employmentFourHeading').append('svg')
			.attr('width', this.employmentOneWIDTH)
			.attr('height', this.employmentOneHEIGHT)
			.append('g')
				.attr('transform', 'translate(0,' + (this.employmentOneHEIGHT/2) + ')');

			this.employmentFiveSvg = d3.select('#employmentFiveHeading').append('svg')
			.attr('width', this.employmentOneWIDTH)
			.attr('height', this.employmentOneHEIGHT)
			.append('g')
				.attr('transform', 'translate(0,' + (this.employmentOneHEIGHT/2) + ')');

			this.textData = d3.shuffle(this.textData).map( (d, i) => {
				d.pos = i;
				return d;
			});

			this.contactText = d3.shuffle(this.contactText).map( (d, i) => {
				d.pos = i;
				return d;
			});

			this.locationText = d3.shuffle(this.locationText).map( (d, i) => {
				d.pos = i;
				return d;
			});

			this.employmentOneText = d3.shuffle(this.employmentOneText).map( (d, i) => {
				d.pos = i;
				return d;
			});

			this.employmentTwoText = d3.shuffle(this.employmentTwoText).map( (d, i) => {
				d.pos = i;
				return d;
			});

			this.employmentThreeText = d3.shuffle(this.employmentThreeText).map( (d, i) => {
				d.pos = i;
				return d;
			});

			this.employmentFourText = d3.shuffle(this.employmentFourText).map( (d, i) => {
				d.pos = i;
				return d;
			});

			this.employmentFiveText = d3.shuffle(this.employmentFiveText).map( (d, i) => {
				d.pos = i;
				return d;
			});

			this.fixName();
			this.fixContactInfo();
			this.fixLocationInfo();
			this.fixEmploymentOneHeading();
			this.fixEmploymentTwoHeading();
			this.fixEmploymentThreeHeading();
			this.fixEmploymentFourHeading();
			this.fixEmploymentFiveHeading();
		},

		updateText(data, svg, letter_width, fontSize)
		{
			var text = this[svg].selectAll('text').data(data, d => d.index);
			text.enter().append('text')
				.attr('fill', d => d.letter === 'M' ? 'tomato' : '#000')
				.attr('x', (d, i) => this[letter_width]*d.pos)
				.style('font-size', fontSize)
				.style('font-family', 'monospace')
				.text(d => d.letter)
				.merge(text)
				.transition().duration(1000)
				.attr('x', (d, i) => this[letter_width]*d.pos);
		},

		fixName()
		{
			let self = this;
			
			self.updateText(this.textData, "nameSvg", "LETTER_WIDTH", "40px");
			window.setTimeout(function () {
				self.textData = self.textData.map( (d, i) => {
					d.pos = d.index;
					return d;
				});
				self.updateText(self.textData, "nameSvg", "LETTER_WIDTH", "40px");
			}, 2000);
		},

		fixContactInfo()
		{
			let self = this;
			
			self.updateText(this.contactText, "contactSvg", "ContactLETTER_WIDTH", "16px");
			window.setTimeout(function () {
				self.contactText = self.contactText.map( (d, i) => {
					d.pos = d.index;
					return d;
				});
				self.updateText(self.contactText, "contactSvg", "ContactLETTER_WIDTH", "16px");
			}, 3700);
		},

		fixLocationInfo()
		{
			let self = this;
			
			self.updateText(this.locationText, "locationSvg", "locationLETTER_WIDTH", "16px");
			window.setTimeout(function () {
				self.locationText = self.locationText.map( (d, i) => {
					d.pos = d.index;
					return d;
				});
				self.updateText(self.locationText, "locationSvg", "locationLETTER_WIDTH", "16px");
			}, 3000);
		},

		fixEmploymentOneHeading()
		{
			let self = this;
			
			self.updateText(this.employmentOneText, "employmentOneSvg", "employmentOneLETTER_WIDTH", "16px");
			window.setTimeout(function () {
				self.employmentOneText = self.employmentOneText.map( (d, i) => {
					d.pos = d.index;
					return d;
				});
				self.updateText(self.employmentOneText, "employmentOneSvg", "employmentOneLETTER_WIDTH", "16px");
			}, 4500);
		},

		fixEmploymentTwoHeading()
		{
			let self = this;
			
			self.updateText(this.employmentTwoText, "employmentTwoSvg", "employmentOneLETTER_WIDTH", "16px");
			window.setTimeout(function () {
				self.employmentTwoText = self.employmentTwoText.map( (d, i) => {
					d.pos = d.index;
					return d;
				});
				self.updateText(self.employmentTwoText, "employmentTwoSvg", "employmentOneLETTER_WIDTH", "16px");
			}, 5100);
		},

		fixEmploymentThreeHeading()
		{
			let self = this;
			
			self.updateText(this.employmentThreeText, "employmentThreeSvg", "employmentOneLETTER_WIDTH", "16px");
			window.setTimeout(function () {
				self.employmentThreeText = self.employmentThreeText.map( (d, i) => {
					d.pos = d.index;
					return d;
				});
				self.updateText(self.employmentThreeText, "employmentThreeSvg", "employmentOneLETTER_WIDTH", "16px");
			}, 5700);
		},
		fixEmploymentFourHeading()
		{
			let self = this;
			
			self.updateText(this.employmentFourText, "employmentFourSvg", "employmentOneLETTER_WIDTH", "16px");
			window.setTimeout(function () {
				self.employmentFourText = self.employmentFourText.map( (d, i) => {
					d.pos = d.index;
					return d;
				});
				self.updateText(self.employmentFourText, "employmentFourSvg", "employmentOneLETTER_WIDTH", "16px");
			}, 5700);
		},
		fixEmploymentFiveHeading()
		{
			let self = this;
			
			self.updateText(this.employmentFiveText, "employmentFiveSvg", "employmentOneLETTER_WIDTH", "16px");
			window.setTimeout(function () {
				self.employmentFiveText = self.employmentFiveText.map( (d, i) => {
					d.pos = d.index;
					return d;
				});
				self.updateText(self.employmentFiveText, "employmentFiveSvg", "employmentOneLETTER_WIDTH", "16px");
			}, 5700);
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-fade {
  display: inherit !important; /* override v-show display: none */
  transition: opacity 0.5s;
}

.v-fade[style*="display: none;"] {
  opacity: 0;
  pointer-events: none; /* disable user interaction */
  user-select: none; /* disable user selection */
}

#employmentContainer, .vision{
	text-align: left;
	margin: auto;
	max-width: 800px;

}


.visionHeader{
	text-align: center;
	font-style: italic;
	font-size: 18px;
}

.employmentLeft{

	float: left;
}

a:link {color: black;}      /* unvisited link */
a:visited {color: black;}   /* visited link */
a:hover {color: black;}     /* mouse over link */
a:active {color: black;}    /* selected link */

a{
	font-family: monospace;
}


.employmentHeader{
	height:90px;
}

.employmentInfo {
	color:black;
}

.employmentLocation {
	color:black;
    margin-top: 10px;
}

.employmentLogo{
	position:relative;
	top:-25px;
	margin:0px;
	padding: 0px;
}

@media screen and (max-width: 770px) {
	.emplogo, .emplogoRh .projImages {
		display: none !important;
	}
}

.emplogo{
	width: 200px;
	animation-name: animatePic;
	animation-duration: 450ms;
	animation-fill-mode: both;
	animation-timing-function: ease-in-out;
	animation-delay: calc(1.2 * 1000ms);
}

.emplogoRh{
	height: 50px;
	position:relative;
	top:27px;
	animation-name: animatePic;
	animation-duration: 450ms;
	animation-fill-mode: both;
	animation-timing-function: ease-in-out;
	animation-delay: calc(1.2 * 1000ms);
}

.profilepic{
	max-height: 250px;
	border-radius: 50%;
}

.wrapper{
	max-width: 1200px;
	margin:auto;
}

.profilePicDiv{
	position:absolute;
	filter: drop-shadow(3px 5px 5px rgba(0, 0, 0, 0.5));
	top:3%;
	animation-name: animatePic;
	animation-duration: 450ms;
	animation-fill-mode: both;
	animation-timing-function: ease-in-out;
	animation-delay: calc(.7 * 1000ms);
    z-index: 1;
}

#pie-chart{
	display: inline-block;
	position:relative;
	width:300px;
	height:300px;
	top:-50px;
}

.projectsList{
	height:130px;
}

@media screen and (max-width: 1100px) {
	#pie-chart {
		display: none !important;
	}

	.skills {
		top: 0px !important;
	}

	#skillsContainer{
		height:320px !important;
	}

	.profilePicDiv {
		display: none !important;
	}

    .projImages {
		display: none !important;
    }

    .column-list {
        width: 390px;
    }

    .projects-column-list {
        width: 390px !important;
        column-count: 1 !important;
    }

    .projectsList {
        height: 220px;
    }
}

#skillsContainer{
	height:250px;
}

.skills{
	display: inline-block;
	position:relative;
	top:-100px;
}

.topArrow{
	position:fixed;
	right: 0;
	bottom: 0;
    background-color: rgba(0,0,0,.4);
    cursor: pointer;
    border-radius: 10px;
    margin: 5px;
}

.employment{
	margin-bottom: 30px;
}

.hr-text {
	line-height: 1em;
	position: relative;
	outline: 0;
	border: 0;
	color: black;
	text-align: center;
	height: 1.5em;
	opacity: .5;
}
.hr-text::before{
	content: '';
	background: linear-gradient(to right, transparent, #4d4c49, transparent);
	position: absolute;
	left: 0;
	top: 50%;
	width: 100%;
	height: 1px;
}
.hr-text::after {
	content: attr(data-content);
	position: relative;
	display: inline-block;
	color: black;
	padding: 0 .5em;
	line-height: 1.5em;
	color: #4d4c49;
	background-color: rgb(243, 243, 243);
}

.projectDet{
	position: absolute;
	width:100%;
}

.projectDetails{
	position: relative;
	max-width: 800px;
    margin:auto;
	height: 400px;
}

.projhr {
    max-width: 800px;
    margin: auto;
}

.projectsContainer {
    max-width: 800px;
    margin: auto;
}

.column-list {
  columns: 105px;
}

.projects-column-list{
	column-count: 2;
}


ul.projects-column-list li{
	display: inline-block !important;
	width: 260px;
	margin-bottom: 24px;
	margin-top: 0px;
	cursor: pointer;
}

.wrappertest{
	transition: transform .2s ease-in-out;
}
.wrappertest:hover{
	-ms-transform: scale(1.1); /* IE 9 */
	-webkit-transform: scale(1.1); /* Safari 3-8 */
	transform: scale(1.1); 
	
}


ul {
  padding: 0;
  display: block;
  margin: 24px auto;
  width: 490px;
}

li {
  display: block;
  height: 35px;
  animation-name: animateIn;
  animation-duration: 350ms;
  animation-delay: calc(var(--animation-order) * 100ms);
  animation-fill-mode: both;
  animation-timing-function: ease-in-out;
  color: #000;
}

li + li {
  margin-top: 16px;
}

@keyframes animateIn {
  0% {
	opacity: 0;
	transform: scale(0.6) translateY(-8px);
  }
  
  100% {
	opacity: 1;
  }
}

@keyframes animatePic {
  0% {
	opacity: 0;
	transform: translateX(-100px);
  }
  
  100% {
	opacity: 1;
  }
}
</style>
